import { createContext, useContext } from "react";
import { AuthContextType } from "@preveil-api";

export const AuthContext = createContext<AuthContextType>({
  setRedirectPath: () => null,
  setProfile: () => null,
  loginComplete: () => null
});

// Description: Hook to consume the auth context
export function useAuthContext(): AuthContextType {
  return useContext(AuthContext);
}
